export default __webpack_public_path__ + "static/media/ovary_risk.4323fb30.jpg";